module.exports = __webpack_public_path__ + "img/chevron-down.df0af47f.svg";